<template>
  <transition name="modal-fade">
    <div v-if="visible" class="modal-mask" @click.self="handleClose">
      <div class="modal-panel" role="dialog" aria-modal="true">
        <button type="button" class="close-btn" aria-label="关闭" @click="handleClose">
          <i class="bi bi-x-lg"></i>
        </button>
        <h2>{{ title }}</h2>
        <div class="content-body">
          <slot>
            <p v-for="(line, idx) in lines" :key="idx">{{ line }}</p>
          </slot>
        </div>
        <div v-if="showFeedbackForm" class="feedback-form">
          <label class="field-label">反馈内容</label>
          <textarea v-model="form.content" class="field-textarea" rows="5" maxlength="2000" placeholder="请描述您遇到的问题或建议（必填）"></textarea>
          <label class="field-label">联系方式（选填）</label>
          <input v-model="form.contact" class="field-input" maxlength="100" placeholder="邮箱或微信，便于我们联系您" />
          <button type="button" class="btn-primary block" :disabled="submitting" @click="handleSubmit">
            {{ submitting ? '提交中...' : '提交反馈' }}
          </button>
          <p v-if="message" class="form-message" :class="{ error: isError }">{{ message }}</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SimpleInfoModal',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    lines: { type: Array, default: () => [] },
    showFeedbackForm: { type: Boolean, default: false },
    submitting: { type: Boolean, default: false },
    message: { type: String, default: '' },
    isError: { type: Boolean, default: false }
  },
  data() {
    return {
      form: { content: '', contact: '' }
    }
  },
  watch: {
    visible(val) {
      if (val && this.showFeedbackForm) {
        this.form = { content: '', contact: '' }
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    handleSubmit() {
      this.$emit('submit', { ...this.form })
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  inset: 0;
  z-index: 2100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.45);
}

.modal-panel {
  position: relative;
  width: 100%;
  max-width: 520px;
  max-height: 80vh;
  overflow: auto;
  padding: 28px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.18);
}

.close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  color: #6b7280;
}

.modal-panel h2 {
  margin: 0 0 16px;
  font-size: 20px;
}

.content-body {
  font-size: 14px;
  line-height: 1.7;
  color: var(--text-secondary);
}

.content-body p {
  margin: 0 0 10px;
}

.feedback-form {
  margin-top: 16px;
}

.field-label {
  display: block;
  margin: 12px 0 6px;
  font-size: 13px;
  color: #374151;
}

.field-textarea,
.field-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
}

.field-input {
  resize: none;
}

.btn-primary.block {
  width: 100%;
  margin-top: 16px;
}

.form-message {
  margin-top: 10px;
  font-size: 13px;
  color: #059669;
}

.form-message.error {
  color: #dc2626;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}
</style>
